import { useSSRSafeId } from '@react-aria/ssr';
import React, { useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { fetchAllCompanies } from '../../../../redux/action/companiesProfile/companies-profile';
import { fetchCompaniesSaloonEdit } from '../../../../redux/action/companiesProfile/companies-profile-saloon-edit';
import { fetchCsrfCookie } from '../../../../redux/action/csrf/csrf-cookie';
import { fetchSaloons } from '../../../../redux/action/saloons/saloons';

const SaloonModal = (props) => {
    const [userId, setUserId] = useState('')
    const [saloonId, setSaloonId] = useState('')
    const dispatch = useDispatch()
    const {t} = useTranslation();
    const companies = useSelector(state => state.all_companies)
    const saloons = useSelector(state => state.saloons)

    useEffect(() => {
        if(!companies) {
            dispatch(fetchAllCompanies())
        }
        if(!saloons.saloons.length) {
            dispatch(fetchSaloons())
        }
    }, [props.id])

    useEffect(() => {
        if (companies.companies.company) {
            setUserId(companies.companies.company.data.filter(item => item.id === props.id)[0].id)
            // setSaloonId(companies.companies.company.data.filter(item => item.id === props.id)[0].saloon_id)
        }
    }, [companies.companies, props.id])

    const saloonChange = (e) => {
        setSaloonId(e.target.value)
    }

    const chooseSaloon = () => {
        if (saloonId === '') {
            toast.dismiss()
            toast.error(t("toast_choose_saloon") , {position: 'bottom-right',className: 'foo-bar'})
        } else {
            const data = {
                profile_id: userId,
                saloon_id: saloonId
            } 
            dispatch(fetchCsrfCookie())
            dispatch(fetchCompaniesSaloonEdit(data))
            props.update()
        }
    }

    return (
        <>
            {props.show && (
                <Modal show={props.show}>
                    <Modal.Header>
                        <Modal.Title>{t("choose saloon")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Select aria-label="Default select example" value={saloonId && saloonId} onChange={saloonChange}>
                                <option value="" hidden>{t("choose saloon")}</option>
                                {saloons.saloons ?
                                    saloons.saloons.map(saloon => (
                                        <option key={saloon.id} value={saloon.id}>{saloon.name}</option>
                                    ))
                                :
                                    'سالن یافت نشد'
                                }
                            </Form.Select>
                            <Button variant="success" onClick={chooseSaloon} className='mt-2'>
                                {t("confirm")}
                            </Button>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={props.handleClick} type='button'>
                            {t("Cancel")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    )
}

export default SaloonModal
